import React, { Dispatch, FC, ReactNode, SetStateAction } from "react";

import TooltipPortal from "src/app/components/TooltipPortal/TooltipPortal";
import { SelectOption } from "src/types";
import AccumulatedLabelsContent from "./AccumulatedLabelsContent";

interface Props {
  multiValue: SelectOption[];
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  emptyFieldPlaceholder: ReactNode;
  handleLabelClick: () => void;
  stackLabels?: boolean;
  readOnly?: boolean;
}

export const AccumulatedLabels: FC<Props> = (props) => {
  const {
    multiValue,
    setIsOpen,
    emptyFieldPlaceholder,
    handleLabelClick,
    stackLabels,
    readOnly,
  } = props;

  const tooltipContent = multiValue.map((item) => item.name).join(", ");

  return (
    <TooltipPortal
      content={tooltipContent}
      noHeightLimit
      contentHidden={!stackLabels}
    >
      <AccumulatedLabelsContent
        multiValue={multiValue}
        emptyFieldPlaceholder={emptyFieldPlaceholder}
        handleLabelClick={handleLabelClick}
        setIsOpen={setIsOpen}
        stackLabels={stackLabels}
        readOnly={readOnly}
      />
    </TooltipPortal>
  );
};
